import { Components } from '@mui/material/styles';
import { alpha } from '@mui/system';
import hexToRGBA from 'theme/hexToRGBA';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

const MuiButton: Components['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      fontWeight: 400,
      textTransform: 'none',
      whiteSpace: 'nowrap',
      minWidth: '2em',
      borderRadius: pxToEm(40),
      '&.underlined': {
        textDecoration: 'underline',
        fontWeight: 'normal',
      },
      '&.dense': {
        padding: 0,
      },
    },
    startIcon: {
      fontSize: '75% !important',
      marginRight: '0',
    },
    endIcon: {
      fontSize: '75% !important',
    },
    containedPrimary: {
      '&:hover, &:focus, &:active': {
        backgroundColor: palette.primary.main,
        boxShadow: `0px 0px 6px ${hexToRGBA(palette.common.black, 0.12)}`,
      },
      '&.Mui-disabled': {
        color: palette.common.white,
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backgroundColor: alpha(palette.grey[600] as string, 0.3),
      },
    },
    containedSecondary: {
      color: palette.primary.main,
      '&:hover, &:focus, &:active': {
        boxShadow: `0px 0px 6px ${hexToRGBA(palette.common.black, 0.12)}`,
      },
    },
    outlinedPrimary: {
      borderWidth: '1.5px !important',
      background: 'none !important',
      '&:hover': {
        borderColor: palette.primary.light,
        color: palette.primary.light,
      },
      '&:focus': {
        borderColor: palette.primary.dark,
        color: palette.primary.dark,
      },
      '&.Mui-disabled': {
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: alpha(palette.grey[600] as string, 0.3),
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        borderColor: alpha(palette.grey[600] as string, 0.3),
      },
    },
    textPrimary: {
      background: 'none !important',
      fontWeight: '400',
      '&:hover': {
        color: palette.primary.light,
      },
      '&:focus': {
        color: palette.primary.dark,
      },
      '&.Mui-disabled': {
        // TODO: refactor without type assertion, or add comment
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: alpha(palette.grey[600] as string, 0.3),
      },
    },
    sizeSmall: {
      padding: `${pxToEm(4)} ${pxToEm(12)}`,
      fontSize: '16px',
      lineHeight: pxToEm(20),
      fontWeight: 400,
    },
    sizeMedium: {
      padding: `${pxToEm(6)} ${pxToEm(16)}`,
      fontSize: '16px',
      lineHeight: pxToEm(22),
    },
    sizeLarge: {
      padding: `${pxToEm(12)} ${pxToEm(24)}`,
      fontSize: '16px',
      lineHeight: pxToEm(24),
    },
  },
};

export { MuiButton };
